import "./css/style.scss";
import Reveal from "./Components/Reveal.jsx";

export default function Footer({ content }) {
  return (
    <section id="footer">
      <Reveal delay={0.2}>
        <div className="section-title">Let's talk</div>
      </Reveal>
      <div className="footer">
        <Reveal delay={0.3}>
          <div className="container">
            <div className="address">
              <div className="title">Address</div>
              <div className="item">{content.address.company}</div>
              <div className="item">{content.address.street}</div>
              <div className="item">{content.address.city}</div>
              <div className="item">{content.address.country}</div>
            </div>
            <div className="other">
              <div className="title">General enquires</div>
              <div className="item" onClick={() => window.open("mailto:" + content.email)}>
                {content.email}
              </div>
              <div className="title">Chamber of Commerce</div>
              <div className="label">{content.chamberOfCommerce}</div>
            </div>
            <div className="socials">
              <div className="title">Socials</div>
              <div className="media-btn" onClick={() => window.open(content.linkedInURL, "_blank")}>
                LinkedIn
              </div>
              <div className="media-btn" onClick={() => window.open(content.instagramURL, "_blank")}>
                Instagram
              </div>
              <div className="media-btn" onClick={() => window.open(content.facebookURL, "_blank")}>
                Facebook
              </div>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.6}>
          <div className="bottom-line">
            <div className="copyright">© {new Date().getFullYear()} Blok74</div>
            <div className="privacy">
              <a onClick={() => window.open("/privacy-policy", "_blank")}> Privacy policy </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
